module.exports = __webpack_public_path__ + "img/henry-ford.1cf62c38.png";